/**
 * Chatwoot chat utility functions
 */

declare global {
  interface Window {
    $chatwoot?: {
      toggle: (state?: 'open' | 'close') => void;
      toggleBubbleVisibility: (state: 'hide' | 'show') => void;
      setUser: (id: string, info: Record<string, any>) => void;
      reset: () => void;
    };
    /**
     * Set by partials/chatwoot.blade.php: runs the callback once the widget
     * is ready, loading it first (it loads after the page, not with it).
     */
    avWithChatwoot?: (callback: () => void) => void;
  }
}

export function isChatwootAvailable(): boolean {
  return typeof window !== 'undefined' &&
    window.$chatwoot !== undefined &&
    typeof window.$chatwoot.toggle === 'function';
}

/** Whether this page uses Chatwoot, even if the widget has not loaded yet. */
export function usesChatwoot(): boolean {
  return isChatwootAvailable() || (typeof window !== 'undefined' && typeof window.avWithChatwoot === 'function');
}

export function openChat(_message?: string): void {
  if (isChatwootAvailable()) {
    window.$chatwoot!.toggle('open');
  } else if (typeof window !== 'undefined' && window.avWithChatwoot) {
    window.avWithChatwoot(() => window.$chatwoot?.toggle('open'));
  }
}

export function hideChat(): void {
  if (isChatwootAvailable()) {
    window.$chatwoot!.toggle('close');
  }
}
